import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTabHistory } from '@/shared/state/use-tab-history';

export function useNavTracking() {
  const { pathname } = useLocation();
  const { recordNav } = useTabHistory();
  useEffect(() => {
    recordNav(pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
}
